import script from "./BookingSetting.vue?vue&type=script&lang=ts&setup=true"
export * from "./BookingSetting.vue?vue&type=script&lang=ts&setup=true"

import "./BookingSetting.vue?vue&type=style&index=0&id=4fc7f832&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4fc7f832"]])

export default __exports__